import {
  CreatePhysicalLocationInput,
  CustomSeoDetail,
  EventNotificationSettings,
  EventRecurrenceConfigInput,
  Media,
  Member,
  PhysicalLocation,
  Space,
  VirtualLocation,
} from '@tribeplatform/gql-client/types'
import { DateValue } from '@tribeplatform/react-ui-kit/DateTimePicker'

export type EventFormFields = {
  title: string
  content: string
  hosts?: Member[]
  capacity?: number
  thumbnail?: Media
  customSeoDetail?: CustomSeoDetail
  notificationSettings: EventNotificationSettings
  physicalLocations?: (CreatePhysicalLocationInput | PhysicalLocation)[]
  virtualLocations?: VirtualLocation[]
  timeZone: string
  startTime: DateValue
  endTime?: DateValue
  targetSpace?: Space
  slug?: string
  recurrenceConfig?: EventRecurrenceConfigInput
}

export enum VirtualLinkProvider {
  Zoom = 'Zoom',
  Meet = 'Meet',
  Youtube = 'Youtube',
  Teams = 'Teams',
  Custom = 'Custom',
}

export enum CalendarProvider {
  Google = 'Google',
  Outlook = 'Outlook',
  Apple = 'Apple',
}
